<template>
  <div class="container">       
      <div v-if="muestraTop">
        <div class="row mt-2">
          <div
            class="col-md-6"
            v-for="item of gcontenido_1"
            :key="'a-' + item.idcontenido"
          >
            <texto
              :id="'txt-' + item.idcontenido"
              :titulo="item.titulo"
              :cuerpo="item.descripcion"
              :enlace="item.enlace"
            />
          </div>
        </div>
        <barra :buscador=true />
      </div>   
      <div v-if="muestraPunto">
        <div class="row mt-0">
          <div class="col-md-12">
            <punto
              titulo="¿Cómo vamos en la implementación del Plan Marco de Implementación (PMI)? - Por puntos "
              subtitulo=""
              linkPath="/avance/punto"
            />
          </div>
        </div>
      </div>  
      <div v-if="muestraClasificacion">
        <div class="row mt-0">
          <div class="col-md-12">
            <clasificacion
              titulo="¿Cómo vamos en la implementación del Plan Marco de Implementación (PMI)? - Por clasificador PMI "
              subtitulo=""
              linkPath="/avance/clasificacion"
            />
          </div>
        </div>
      </div>
  
      <v-card v-if="muestraIntro" class="mb-8 mt-4">
        <v-card-text v-html="intro" justify />
      </v-card>
     <v-snackbar v-model="snack" :timeout="5000" :color="MesaggeInfo.color">
      
      {{ this.MesaggeInfo.mensajeRespuesta }} {{this.MesaggeInfo.codigoRespuesta}}
      <v-btn text @click="snack = false">Cerrar</v-btn>
    </v-snackbar>
  
  </div>
</template>

<script>
// https://vuetifyjs.com/en/styles/transitions

import Punto from "@/components/content/punto.vue";
import Clasificacion from "@/components/content/clasificacion.vue";
import texto from "@/components/content/texto.vue";
import barra from "@/components/content/barra-nav.vue";
import { mapActions, mapGetters } from "vuex";
let pauseTime = 1;

export default {
  mounted() {
    this.muestraIntro = true;
    setTimeout(
      function() {
        this.muestraClasificacion = true;
        setTimeout(
          function() {
            this.muestraPunto = true;
            setTimeout(
              function() {
                this.muestraTop = true;
              }.bind(this),
              pauseTime
            );
          }.bind(this),
          pauseTime
        );
      }.bind(this),
      pauseTime * 2
    );
  },
  data: () => ({
    url: process.env.VUE_APP_REST,
    muestraTop: false,
    muestraBarra: false,
    muestraPunto: false,
    muestraClasificacion: false,
    muestraIntro: false,
    intro:
      "La veracidad, exactitud y oportunidad de los datos registrados en SIIPO son responsabilidad exclusiva de la entidad asignada para cada indicador y se rige por los principios establecidos en la Ley 1712 de 2014. Si requiere mayor detalle sobre la información reportada, deberá solicitarla a la entidad responsable.",
      //control de errores
      snack: false,
      snackColor: "",
      snackText: "",      
      MesaggeInfo: [{ codigoRespuesta: "", color: "", mensajeRespuesta: "" }],
  }),
  components: {
    Punto,
    Clasificacion,
    texto,
    barra
  },
  computed: {
    ...mapGetters(["gcontenido_1"]),
    ...mapGetters("mensaje", ["ginformation", "gnodata"])
  },
  methods: {
    ...mapActions(["textosTodos"]),
    SetButtons() {
      let payload = { boton: 0 };
      this.$store.dispatch("barra/setstate", payload);
    }
  },
  created() {  
    this.textosTodos();
    this.SetButtons();
  },
  watch: {
     ginformation() {
      this.MesaggeInfo = this.ginformation;
      console.log(this.MesaggeInfo.mensajeRespuesta);
      this.snack = true;
    }
  }
};
</script>